import { useEffect, useState } from 'react';
import {
  Card, Stack, Button, Container, Typography, Box, CircularProgress, Modal
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiget } from '../../service/api';

const CherryCreek = () => {
  const [stationData, setStationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = (e, id) => {
    e.stopPropagation(); // Prevent row selection
    navigate(`/dashboard/cherrycreek/${id}`);
  };

  const columns = [
    {
      field: 'TransactionID',
      headerName: 'Transaction ID',
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
          onClick={(e) => handleNavigate(e, params.row.TransactionID)}
        >
          {params.value}
        </Box>
      )
    },
    {
      field: 'LenderLoanNumber',
      headerName: 'Loan Number',
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
          onClick={(e) => handleNavigate(e, params.row.TransactionID)}
        >
          {params.value}
        </Box>
      )
    },
    {
      field: 'Borrower1FullName',
      headerName: 'Borrower Name',
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
          onClick={(e) => handleNavigate(e, params.row.TransactionID)}
        >
          {params.value}
        </Box>
      )
    },
    {
      field: 'CurrentStationName',
      headerName: 'Station',
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{ cursor: 'pointer', color: 'primary.main', textDecoration: 'underline' }}
          onClick={(e) => handleNavigate(e, params.row.TransactionID)}
        >
          {params.value}
        </Box>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <Button
            variant="text"
            size="small"
            color="primary"
            onClick={(e) => handleNavigate(e, params.row.TransactionID)}
          >
            View
          </Button>
        </Stack>
      )
    }
  ];

  const fetchStations = async () => {
    try {
      setLoading(true);
      const res = await apiget('cherrycreek/stationsloan');
      if (res?.status === 200) {
        setStationData(res.data.result);
      }
    } catch (error) {
      console.error('Error fetching Cherry Creek stations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStations();
  }, []);

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent="space-between">
          <Typography variant="h4">Cherry Creek Stations</Typography>
        </Stack>
        <Box width="100%">
          <Card style={{ height: '600px', paddingTop: '15px' }}>
            <DataGrid
              rows={stationData}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
              getRowId={(row) => row.TransactionID}
              checkboxSelection
              disableSelectionOnClick
            />
          </Card>
        </Box>
      </Container>

      <Modal open={loading}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Loading station data...</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default CherryCreek;
